"use client";

import { twMerge } from "tailwind-merge";

import { NormalText } from "@/components/text/NormalText";
import { allGenderFilters } from "@/constants/selectArtistFilters";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";
import { classNames } from "@/utils/classNames";

export function GenderFilterPart({
  className,
  namespace,
}: {
  namespace: string;
  className?: string;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const genderFilterShow = useSelectArtistFilters(
    (state) => state.genderFilterShow
  );
  const toggleGenderFilterShow = useSelectArtistFilters(
    (state) => state.toggleGenderFilterShow
  );

  const allGendersSelected = allGenderFilters.every((model) =>
    genderFilterShow.has(model)
  );

  return (
    <div className={twMerge("", className)}>
      <NormalText elementType="p" className="mb-1 text-gray-400">
        GENDER
      </NormalText>
      <div className="grid w-fit grid-cols-2">
        {allGenderFilters.map((filter, index) => (
          <button
            key={filter}
            className={classNames(
              genderFilterShow.has(filter) && !allGendersSelected ?
                "border-primary bg-primaryLight"
              : "border-gray-400 bg-white",
              index % 2 === 0 ? "rounded-l-3xl" : "rounded-r-3xl",
              "border px-2 py-1 transition-colors"
            )}
            onClick={() => toggleGenderFilterShow(filter)}
            data-tutorial={`gender-filter-${filter}`}
          >
            <NormalText
              elementType="span"
              className={classNames(
                genderFilterShow.has(filter) && !allGendersSelected ?
                  "text-gray-900"
                : "text-gray-900",
                "transition-colors"
              )}
            >
              {filter}
            </NormalText>
          </button>
        ))}
      </div>
    </div>
  );
}
